import { FlowsFIRenewalLoginModel, LoginOrderResponse } from "./flows-fi-renewal-login.element.model";

export namespace FlowsFIRenewalLoginAction {
  export class Focused {
    static readonly type = "[FlowsFIRenewalLogin] Focused";
    constructor() {}
  }
  export class Loading {
    static readonly type = "[FlowsFIRenewalLogin] Loading";
  }
  export class Submit {
    static readonly type = "[FlowsFIRenewalLogin] Submit";
    constructor(public flowsFIRenewalLoginModel: FlowsFIRenewalLoginModel) {}
  }
  export class Completed {
    static readonly type = "[FlowsFIRenewalLogin] Completed";
    constructor(public response: LoginOrderResponse) {}
  }

  export class Errorred {
    static readonly type = "[FlowsFIRenewalLogin] Errorred";
  }

  export class Redirect {
    static readonly type = "[FlowsFIRenewalLogin] Redirect";
    constructor(public flowsFIRenewalLoginModel: FlowsFIRenewalLoginModel) {}
  }
}
